import { Card } from '@/components/ui/card';
import { ColumnChart } from '@/features/dashboard-charts';
import type { ChartData } from '@/entities/dashboard';

interface ActivityChartProps {
  data: ChartData;
  isLoading: boolean;
}

export function ActivityChart({ data, isLoading }: ActivityChartProps) {
  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold">Service Activity by Partner</h3>
        <p className="text-sm text-muted-foreground">
          Breakdown of received, released, and dispatched volumes across service partners
        </p>
      </div>
      <ColumnChart data={data} height={400} loading={isLoading} />
    </Card>
  );
}
